import React from 'react';
const stats = [{
  value: '+500',
  label: 'Coaches',
  color: 'text-[#6B2FB3]'
}, {
  value: '6+5',
  label: 'Volumes & Bonuses',
  color: 'text-[#6B2FB3]'
}, {
  value: '4.9/5',
  label: 'Rating ⭐',
  color: 'text-[#6B2FB3]'
}, {
  value: '🌍',
  label: 'Worldwide',
  color: 'text-[#0A0A0A]'
}];
const testimonials = [{
  quote: 'I planned my entire season in a single evening. Now every practice has a clear objective.',
  name: 'Sarah M.',
  role: 'Manchester, UK'
}, {
  quote: 'My players are improving so much faster now that they finally follow a logical progression.',
  name: 'Coach Emma',
  role: 'Auckland, NZ'
}, {
  quote: 'I no longer spend hours on YouTube hunting for drills. I open Netball Ready 360 and it is all there.',
  name: 'Lisa T.',
  role: 'Perth, Australia'
}];
export function SocialProofBar() {
  return <section className="w-full bg-white py-12 px-4 border-b border-[#E5E5EA]" data-id="element-200">
      <div className="max-w-5xl mx-auto" data-id="element-201">
        <div className="flex flex-wrap items-center justify-around gap-6 bg-[#FAFAFA] border border-[#E5E5EA] rounded-2xl px-6 py-6 mb-10 shadow-sm" data-id="element-202">
          {stats.map((s, i) => <div key={i} className="text-center min-w-[100px]" data-id="element-203">
              <div className={`text-3xl sm:text-4xl font-black ${s.color} tracking-tight`} data-id="element-204">
                {s.value}
              </div>
              <div className="text-[#5A5A66] text-xs sm:text-sm font-bold mt-1 uppercase tracking-wider" data-id="element-205">
                {s.label}
              </div>
            </div>)}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-206">
          {testimonials.map((t, i) => <div key={i} className="bg-white border border-[#E5E5EA] rounded-2xl p-6 shadow-sm flex flex-col" data-id="element-207">
              <div className="text-[#FFD700] text-lg mb-3" data-id="element-208">⭐⭐⭐⭐⭐</div>
              <p className="text-[#0A0A0A] text-sm sm:text-base font-medium italic flex-1 mb-4 leading-relaxed" data-id="element-209">
                "{t.quote}"
              </p>
              <div data-id="element-210">
                <div className="font-black text-[#0A0A0A] text-sm" data-id="element-211">
                  {t.name}
                </div>
                <div className="text-[#5A5A66] text-xs font-semibold" data-id="element-212">
                  {t.role}
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}